document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Scientific Articles sliders
  const sliders = document.querySelectorAll('[data-slider]');

  sliders.forEach(slider => {
    new ArticlesSlider(slider);
  });
});

class ArticlesSlider {
  constructor(sliderElement) {
    this.slider = sliderElement;
    this.slides = this.slider.querySelectorAll('[data-slide]');
    this.prevBtn = this.slider.closest('.articles-slider-wrapper').querySelector('[data-prev]');
    this.nextBtn = this.slider.closest('.articles-slider-wrapper').querySelector('[data-next]');
    // Dots removed - no dotsContainer or dots variables needed

    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.slidesPerView = this.getSlidesPerView();
    this.maxSlideIndex = Math.max(0, this.totalSlides - this.slidesPerView);

    this.init();
  }

  init() {
    if (this.totalSlides <= this.slidesPerView) return;

    this.setupEventListeners();
    this.updateNavigation();
  }

  getSlidesPerView() {
    const width = window.innerWidth;

    if (width >= 1024) {
      // Desktop: 3 slides
      return 3;
    } else if (width >= 768) {
      // Tablet: 2 slides
      return 2;
    } else {
      // Mobile: 1 slide
      return 1;
    }
  }

  setupEventListeners() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prevSlide());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }

    // Keyboard navigation
    this.slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        this.nextSlide();
      }
    });

    // Touch/swipe support
    this.addTouchSupport();
  }

  updateNavigation() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentSlide === 0;
    }

    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentSlide >= this.maxSlideIndex;
    }

    // Dots removed - no dots to update
  }

  goToSlide(slideIndex) {
    if (slideIndex < 0 || slideIndex > this.maxSlideIndex) return;

    this.currentSlide = slideIndex;

    // Calculate scroll position based on slide width
    const slideWidth = this.slides[0].offsetWidth;
    const gap = 20; // Gap between slides (matches CSS)
    const scrollLeft = slideIndex * (slideWidth + gap);
    this.slider.scrollLeft = scrollLeft;

    this.updateNavigation();
  }

  nextSlide() {
    if (this.currentSlide < this.maxSlideIndex) {
      this.goToSlide(this.currentSlide + 1);
    }
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.goToSlide(this.currentSlide - 1);
    }
  }

  addTouchSupport() {
    let startX = 0;
    let startY = 0;
    let isScrolling = null;

    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });

    this.slider.addEventListener('touchmove', (e) => {
      if (!startX || !startY) return;

      const deltaX = e.touches[0].clientX - startX;
      const deltaY = e.touches[0].clientY - startY;

      // Determine if scrolling horizontally or vertically
      if (isScrolling === null) {
        isScrolling = Math.abs(deltaX) > Math.abs(deltaY) ? 'horizontal' : 'vertical';
      }

      if (isScrolling === 'horizontal') {
        e.preventDefault();
      }
    });

    this.slider.addEventListener('touchend', (e) => {
      if (!startX || isScrolling !== 'horizontal') return;

      const endX = e.changedTouches[0].clientX;
      const deltaX = endX - startX;

      // Minimum swipe distance (adjusted for multi-slide)
      const minSwipeDistance = 50;

      if (Math.abs(deltaX) > minSwipeDistance) {
        if (deltaX > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      }

      startX = 0;
      startY = 0;
      isScrolling = null;
    });
  }

  destroy() {
    // Clean up event listeners if needed
  }
}